const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"

const profile = {
  id: 1,
  pseudoFirstName: "Nina",
  pseudoLastName: "Lopata",
  profileImage: {
    id: 9, //baseUrl + "/15/thumbnail?w=320&h=320&auto",
  },
  // profilePDFImage: baseUrl + "/15/thumbnail?w=320&h=200&auto",
  images: [
    {id: 1}, 
    {id: 2},
    {id: 3}, 
    {id: 4},
    {id: 5},
    {id: 6}, 
    {id: 7},
    {id: 8},
    // { thumbnail: baseUrl + "/1/thumbnail?w=240&h=360&auto", mini: baseUrl + "/1/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/1"},
    // { thumbnail: baseUrl + "/2/thumbnail?w=240&h=360&auto", mini: baseUrl + "/2/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/2"},
    // { thumbnail: baseUrl + "/3/thumbnail?w=240&h=360&auto", mini: baseUrl + "/3/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/3"},
    // { thumbnail: baseUrl + "/4/thumbnail?w=240&h=360&auto", mini: baseUrl + "/4/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/4"},
    // { thumbnail: baseUrl + "/5/thumbnail?w=240&h=360&auto", mini: baseUrl + "/5/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/5"},
    // { thumbnail: baseUrl + "/6/thumbnail?w=240&h=360&auto", mini: baseUrl + "/6/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/6"},
    // { thumbnail: baseUrl + "/7/thumbnail?w=240&h=360&auto", mini: baseUrl + "/7/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/7"},
    // { thumbnail: baseUrl + "/8/thumbnail?w=240&h=360&auto", mini: baseUrl + "/8/thumbnail?w=50&h=50&auto&minScale=0.75", fullsize: baseUrl + "/8"},
   // { thumbnail: "/Nina – Cyrille Joubert Talents_files/Nina-Lopata_9-300x214.png", fullsize: "/Nina – Cyrille Joubert Talents_files/Nina-Lopata_9-600.png"},
  ],
  agents: [{
    name: "Cyrille Joubert",
    mail: "castingcyril@gmail.com",
    phone: "+33 6 62 63 47 24",
  }],
  description: "<h3>Sport</h3>\
Niveau compétition : Ski alpin, Boxe, Danse, Danse contemporaine\
<h3>Danses</h3>\
Cabaret (professionnel), Classique (professionnel), Contemporaine (professionnel)",
  categories: [
    "Comédienne", "Scénariste"
  ],
  videos: [
    {title: "Bande démo", url: "https://www.youtube.com/watch?v=fs8XJSXva44"},
    {title: "Bande démo", url: "http://www.youtube.com/embed/fs8XJSXva44?autoplay=0&enablejsapi=1&wmode=opaque"},
  ],
  languages: [
    {lang: "FR"},
    {lang: "EN", level: {label: "lu, écrit, parlé"}}
  ],
  cv: [
    {
      title: "Cinéma",
      entries: [
        {date: 2016,	  	title: "À bras ouverts", director: "Philippe De Chauveron"},
        {date: 2015,  	title: "Les Visiteurs 3", director: "Jean-Marie Poiré"},
        {date: undefined,  	title: "Embarquement immédiat", director: "Philippe de Chauveron"},
        {date: 2014,  	title: "La Véritable Histoire de Robin des Bois", director: "Anthony Marciano"},
        {date: 2013,  	title: "Qu'Est-Ce Qu'On A Fait Au Bon Dieu ?", director: "Philippe De Chauveron"},
        {date: 2012,  	title: "La Grande Boucle", director: "Laurent Tuel"},
        {date: undefined,  	title: "Chimpanzés", director: "Mark Linfield Et Alastair Fothergill"},
        {date: undefined,  	title: "Vive la France", director: "Michaël Youn"},
        {date: undefined,  	title: "Hôtel Normandy", director: "Charle Nemes"},
        {date: 2011,  	title: "Dépression Et Des Potes", director: "Arnaud Lemort"},
        {date: 2010,  	title: "De l'Huile sur le Feu", director: "Nicolas Benamou"},
        {date: undefined,  	title: "Fatal", director: "Michaël Youn"},
        {date: 2009,  	title: "Tellement Proches", director: "Eric Toledano et Olivier Nakache"},
        {date: undefined,  	title: "Coco", director: "Gad Elmaleh"},
        {date: undefined,  	title: "Tu Peux Garder Un Secret", director: "Alexandre Arcady"},
      ]
    },
    {
      title: "Télévision",
      entries: [
        {date: 2013,  	title: "L'Esprit De Famille", director: "Frédéric Berthe"},
        {date: 2013,  	title: "Scènes de Ménages", comment: "Spécial Guest"},
        {date: "2011 - 2010",  	title: "Ce soir avec Arthur"},
        {date: 2008,  	title: "Inéluctable", director: "François Luciani"},
        {date: undefined,  	title: "La Traque", director: "Laurent Jaoui"},
        {date: undefined,  	title: "Nos Années Pension", director: "Thibault Staib, Alain Rudaz et Luc Di Rosa", comment: "Saison 2 Et 3"},
        {date: 2003,  	title: "Voyage Au Bout De L'Humour Juif", director: "Alex Szalat"},
        {date: 2002,  	title: "La Grande Brasserie", director: "Dominique Baron"},
        {date: 2001,  	title: "Tutti Frutti", director: "Serge Kalfon, présenté par Nagui"},
        {date: 1999,  	title: "Sur La Vie D'Ma Mère", director: "Philippe Layani"},
        {date: undefined,  	title: "Les Coups D'Humours", director: "Emmanuelle Carriau"},
      ]
    }
  ]
}

export default profile


/** WEBPACK FOOTER **
 ** ./src/profile/data.js
 **/